"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonMedia = require("@mmc/common-media");

var _m = _interopRequireDefault(require("../styles/m-43.css"));

var _m2 = _interopRequireDefault(require("./m-43.props/m-43.defaultProps"));

var _m3 = _interopRequireDefault(require("./m-43.props/m-43.propTypes"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var imageWidth = 1080;

var ImageBlock = function ImageBlock(_ref) {
  var data = _ref.data,
      theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _m["default"].imageWrapper
  }, /*#__PURE__*/_react["default"].createElement(_commonMedia.CommonMedia, {
    theme: theme,
    mediaClasses: [_m["default"].backgroundImage],
    size: imageWidth,
    image: handleNestedProp(data, 'data.image'),
    sizes: "(min-width: 768px) 40vw, 80vw"
  }));
};

ImageBlock.displayName = 'ImageBlock';
ImageBlock.defaultProps = {
  data: _m2["default"],
  defaultData: _m2["default"],
  theme: {}
};
var _default = ImageBlock;
exports["default"] = _default;